<template>
  <div class="dashboard-section">
    <div>
      <h5>Please Choose a Table to Order</h5>
    </div>
    <b-container fluid>
      <div v-if="loading" class="loading" style="text-align:center;margin-top: 100px">
        <b-spinner variant="danger" />
      </div>
      <div v-if="!loading" class="row mt-2 mb-2">
        <b-button
          v-for="(item,i) in sortedTables"
          v-show="item.status==='1'"
          :key="i"
          size="lg"
          :class="!item.hasOrder?'':'disabled-table-number'"
          variant="outline-success"
          style="margin: 10px"
          @click="handleClick(item.qdo_url,item.number)"
        >
          {{ item.number }}
        </b-button>
      </div>
    </b-container>
  </div>
</template>
<script>
const reverseStringToArray = str => {
  const splitString = str.split('');
  const reverseArray = splitString.reverse();
  return reverseArray;
};
// 生成x-y的随机数
const getRandomNumber = (x, y) => {
  return Math.floor(x + Math.random() * y);
};
const BASE_STRING = 'abcdefghigklmnopqrstuvwxyz';
function shuffle() {
  const array = BASE_STRING.split('');
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array.join('');
}
const getRandomStrFromTime = () => {
  const time = new Date().getTime();
  const timeArray = reverseStringToArray(`${time}`);
  const randomArray = timeArray.map(item => {
    const number = getRandomNumber(0, 2);
    return `${item}${shuffle().substr(0, number)}`;
  });
  return randomArray.join('');
};
export default {
  data() {
    return {
      outletTables: [],
      loading: true,
      sortedTables: []
    };
  },

  mounted() {
    this.getTables();
  },
  methods: {
    sortTablesFunction() {
      this.sortedTables = this.outletTables.sort(function(a, b) {
        return isNaN(a.number) || isNaN(b.number)
          ? a.number.localeCompare(b.number)
          : parseInt(a.number) < parseInt(b.number);
      });
    },
    async getTables() {
      let outletCodes = JSON.parse(
        localStorage.getItem('pos-order-outlet') || '{}'
      );
      if (outletCodes.value) {
        await this.$store
          .dispatch('GetStoreTables', outletCodes.value)
          .then(res => {
            this.loading = false;
            for (const tb of res.data) {
              if (tb.status === '1') this.outletTables.push(tb);
            }
            this.sortTablesFunction();
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      }
    },
    handleClick(url, table) {
      const type = this.$route.query.type;
      sessionStorage.setItem('table_no', table);
      if (type === 'post_pay') {
        this.$router.push('/pos-order?type=table-order');
      } else {
        window.location.href =
          url + '&k=' + getRandomStrFromTime() + '&source=QBIZ';
      }
    }
  }
};
</script>
<style scoped>
.disabled-table-number {
  pointer-events: none;
  background: #eee;
  border-color: #eee;
  color: #9e9e9e;
}
</style>
